import {connect} from 'react-redux';
import {CartFooterComponent} from '../../Component/Cart/CartFooterComponent';
import {RootState} from '../../Store';

interface OwnProps {
}

type StateProps = OwnProps & {
  totalAmount: number;
};

interface DispatchProps {
}

export type CartFooterContainerProps = StateProps & DispatchProps;

const mapStateToProps = (state: RootState): StateProps => ({
  totalAmount: state.cart.cartItems.length,
});

export const CartFooterContainer = connect<StateProps, DispatchProps, OwnProps, RootState>(mapStateToProps)(CartFooterComponent);
